import React from "react";

function AddLinkPopup({ setShowLinkBox, onChangeLinkValue, linkValue, handleSaveLink }) {
    return (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-body" style={{ fontSize: "17px", fontWeight: "500" }}>
                        <input
                            type="text"
                            className="form-control w-100"
                            placeholder="Add link here"
                            aria-label="addLink"
                            value={linkValue}
                            aria-describedby="basic-addon1"
                            onChange={(e) => onChangeLinkValue(e.target.value)}
                            style={{ height: "40px", width: "250px" }}
                        />
                    </div>
                    <hr style={{ margin: "15px 0px" }} />
                    <div>

                        <button className="linkSaveBtn" disabled={!linkValue} style={{ float: "right", marginLeft: "10px" }} onClick={() => handleSaveLink()}>Save</button>
                        <button type="button" className="btn btn-secondary" style={{ float: "right" }} onClick={() => {
                            setShowLinkBox(false)
                        }}>Close</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddLinkPopup;
